import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Close } from '@lyearn/icons';
import { AddBlock } from '@lyearn/molecules';
import { Input, Stack, Typography } from '@lyearn/ui';

import { FtbIncorrectOptionsEditorProps } from './types';

const FtbIncorrectOptionsEditor: React.FC<FtbIncorrectOptionsEditorProps> = (props) => {
  const { globalDistractors, onChange, error } = props;

  const { t } = useTranslation();

  const onAddOption = useCallback(() => {
    onChange([...globalDistractors, { text: '' }]);
  }, [globalDistractors, onChange]);

  const onChangeOption = useCallback(
    (updatedValue: string, updateIndex: number) => {
      const updatedGlobalDistractors = globalDistractors.map((distractor, index) =>
        updateIndex === index ? { id: distractor.id, text: updatedValue } : distractor,
      );
      onChange(updatedGlobalDistractors);
    },
    [globalDistractors, onChange],
  );

  const onRemove = useCallback(
    (index: number) => {
      const globalDistractorsCopy = [...globalDistractors];
      const updatedGlobalDistractors = globalDistractorsCopy.filter(
        (_, currentIndex) => currentIndex !== index,
      );
      onChange(updatedGlobalDistractors);
    },
    [globalDistractors, onChange],
  );

  return (
    <Stack direction="col" gapY={16}>
      {error?.message === t('QuizCreator:Validations.AtleastOneDistractorRequired') ? (
        // rethink this check later, maybe using type
        <Typography className="-mt-16 ms-8" color="text-text-error" variant="body-short-02">
          {error.message}
        </Typography>
      ) : null}
      {globalDistractors.map((distractor, index) => {
        const isError = error && !distractor.text;

        return (
          <Stack key={index} direction="col">
            <Input
              endAdornment={
                <Close
                  className="h-20 w-20 cursor-pointer text-icon-placeholder hover:text-icon-secondary"
                  onClick={() => onRemove(index)}
                />
              }
              error={isError}
              placeholder={t('QuizCreator:QuestionsSettings.Distractor', { index: index + 1 })}
              value={distractor.text}
              onChangeText={(value: string) => onChangeOption(value, index)}
            />
            {isError ? (
              <Typography className="ms-8" color="text-text-error" variant="body-short-02">
                {t('QuizCreator:Validations.DistractorCantBeEmpty')}
              </Typography>
            ) : null}
          </Stack>
        );
      })}
      <AddBlock
        className="w-full"
        length="short"
        title={t('QuizCreator:QuestionsSettings.AddDistractor')}
        onClick={onAddOption}
      />
    </Stack>
  );
};

export default FtbIncorrectOptionsEditor;
